/**
 * Side by side, except from `lg` to `step-row`, where the step rail leaves them too little room: there they stack, and
 * the arrow that goes from one to the other has no place. The header and its skeleton lay out alike.
 */
export const HEADER_LAYOUT_CLASS_NAME = 'sm:flex lg:block step-row:flex';
export const REVIEWEES_LAYOUT_CLASS_NAME = 'relative sm:ml-10 lg:ml-0 step-row:ml-30';
export const ARROW_CLASS_NAME =
    'pointer-events-none absolute z-10 hidden w-100 rotate-12 sm:top-30 sm:-left-[300px] sm:max-lg:block step-row:top-25 step-row:-left-[325px] step-row:block';
